import store from "../../../store";

export default [
  {
    path: "/registerQueues",
    name: "registerQueues",
    component: () => import(/*webpackChunckName: "registerQueues" */ "./RegisterQueues.vue"),
    beforeEnter: (to, from, next) => {
      if (store.getters["auth/hasRole"] === "admin") {
        next();
      } else {
        next({ name: "attendance" });
      }
    },
  },
];
